// extracted by mini-css-extract-plugin
export default {"code-break-button":"CodeBreakButton_code-break-button__wG9nZ","code-break-button-text":"CodeBreakButton_code-break-button-text__MZE8x"};